export const BARCODE_DETECTOR_FORMATS = [
  'aztec',
  'code_128',
  'code_39',
  'code_93',
  'codabar',
  'data_matrix',
  'ean_13',
  'ean_8',
  'itf',
  'pdf417',
  'qr_code',
  'upc_a',
  'upc_e',
] as const;

export const BARCODE_SCAN_DEDUPE_MS = 1200;

export interface BarcodeDetectorInstance {
  detect: (image: ImageBitmapSource) => Promise<Array<{ rawValue: string }>>;
}

export type BarcodeDetectorConstructor = new (options?: {
  formats?: readonly string[];
}) => BarcodeDetectorInstance;

export const getBarcodeDetectorConstructor = (): BarcodeDetectorConstructor | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return (window as unknown as { BarcodeDetector?: BarcodeDetectorConstructor }).BarcodeDetector;
};
